import { itemAmountNet } from "./pockMath";

/** The POCK line fields the money math needs. `null` = rate-masked for this viewer
 * (rate_visibility nulls both the rate and the stored amount server-side). */
export interface ProtocolValueItem {
  completion_percentage: string;
  order_line_item_quantity: string;
  order_line_item_unit_rate: string | null;
  amount_net: string | null;
}

export interface ProtocolValueSource {
  pock_approved_settlement_pct?: string;
  items: ProtocolValueItem[];
}

/** Net value of a protocol: stored amount_net when present, otherwise qty × completion%
 * × rate × settlement% — same formula as ProtocolDetailPage. Items with both amount_net
 * and unit_rate null are rate-masked for this viewer and counted separately, so the
 * caller can mark a partial sum instead of understating it silently. */
export function protocolNetValue(p: ProtocolValueSource): { value: number; masked: number } {
  const settlementPct = parseFloat(p.pock_approved_settlement_pct ?? "100") || 100;
  let value = 0;
  let masked = 0;
  for (const it of p.items) {
    if (it.amount_net != null) {
      const v = parseFloat(it.amount_net);
      if (!isNaN(v)) value += v;
    } else if (it.order_line_item_unit_rate != null) {
      value += itemAmountNet(
        it.order_line_item_quantity,
        it.order_line_item_unit_rate,
        it.completion_percentage,
        100,
        settlementPct,
      );
    } else {
      masked += 1;
    }
  }
  return { value, masked };
}

/** Protocols that count against the order's value. Withdrawn and contractor-rejected
 * ones don't — a corrected re-issue would double the deduction otherwise. */
export function isSettledProtocol(p: {
  is_withdrawn: boolean;
  accepted_by_contractor: boolean | null;
}): boolean {
  return !p.is_withdrawn && p.accepted_by_contractor !== false;
}
